import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import type { ReactNode } from "react";

export function TooltipHelper({ title }: { title: ReactNode }) {
  return (
    <Tooltip title={title}>
      <HelpOutlineIcon fontSize="small" color="primary" />
    </Tooltip>
  );
}
